import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      created_at: item.created_at,
      query_data: item.query_data,
      fields: item.fields,
      view: item.view,
      url: item.url,
      status: item.status,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getDataExports({ payload: { signal, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.data_export.get,
      params: { page: curr_page },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getDataExportsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getDataExportsFailed,
      endpoint: api.data_export.get.url
    });
  }
}

export const getDataExportsSaga = takeEvery(types.GET_DATA_EXPORTS_REQUEST, getDataExports);